import { render, staticRenderFns } from "./myTripDetail.vue?vue&type=template&id=32fc68f6&"
import script from "./myTripDetail.vue?vue&type=script&lang=js&"
export * from "./myTripDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports